export default __webpack_public_path__ + "static/media/Map_Sodar.0d1e64a9.svg";